import { render } from "./Onhold.vue?vue&type=template&id=dd84653c&scoped=true"
import script from "./Onhold.vue?vue&type=script&lang=js"
export * from "./Onhold.vue?vue&type=script&lang=js"

import "./Onhold.vue?vue&type=style&index=0&id=dd84653c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd84653c"]])

export default __exports__